import { getAPICallWithParams, getAPICall, postAPICall } from './BaseAPI';

// FunOnHHI support messaging (admin side). Talks to bohdisys-api /support/*.

export const getConversations = (
  params: { page?: number; limit?: number; search?: string } = {},
  cb = (jR, s, e) => {},
) => {
  const query: Record<string, string> = {};
  if (params.page) query.page = String(params.page);
  if (params.limit) query.limit = String(params.limit);
  if (params.search) query.search = params.search;
  getAPICallWithParams('support/conversations', query, cb);
};

export const getConversationThread = (phone: string, cb = (jR, s, e) => {}) => {
  getAPICall(`support/conversations/${encodeURIComponent(phone)}/messages`, cb);
};

export const postSupportReply = (phone: string, body: string, cb = (jR, s, e) => {}) => {
  postAPICall(`support/conversations/${encodeURIComponent(phone)}/messages`, { body }, cb);
};

export const markConversationRead = (phone: string, cb = (jR, s, e) => {}) => {
  postAPICall(`support/conversations/${encodeURIComponent(phone)}/read`, {}, cb);
};

export const getCustomerContext = (phone: string, cb = (jR, s, e) => {}) => {
  getAPICall(`support/customer-context/${encodeURIComponent(phone)}`, cb);
};
